import React, { createContext, useContext } from 'react';

export const Templates = createContext({});

export const TemplatesProvider = ({ children, serverPageId }) => {
  return (
    <Templates.Provider value={{ serverPageId }}>{children}</Templates.Provider>
  );
};

export default TemplatesProvider;

export const useTemplates = () => {
  return useContext(Templates);
};
